<div class="flex justify-center items-center w-full h-[200px]">
    <div class="flex flex-col items-center font-bold text-white text-[40px]">
        <p>Hurra!</p>
        <p>{{'SUCCESS_PAGE.Alles lief wie erwartet' | translate}}.</p>
        <p>{{'SUCCESS_PAGE.Weitere Infos finden Sie in Ihrem' | translate}} <a href="/profile" class="underline"> {{'PROFILE.profile' | translate}}.</a></p>
    </div>
</div>
